import React, { useState, useRef, useEffect } from 'react'
import { ShareIcon } from '@primer/octicons-react'
import {
  WhatsappShareButton,
  FacebookShareButton,
  TwitterShareButton,
  TelegramShareButton,
  WhatsappIcon,
  FacebookIcon,
  TwitterIcon,
  TelegramIcon,
} from 'react-share'
import { useStaticQuery, graphql } from 'gatsby'

const SocialShare = ({
  path,
  className,
  title = '',
  hashtag = 'Elecciones2021CL',
}) => {
  const dropdownRef = useRef(null)

  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            siteName
            description
            url
            author
            domain
            twitterHandle
          }
        }
      }
    `,
  )

  const [open, setOpen] = useState(false)

  const shareUrl = `${site.siteMetadata.url}/${path}`

  const suffix = medium => {
    return `?utm_source=sharer&utm_medium=${medium}`
  }

  useEffect(() => {
    const clickEnPagina = e => {
      if (dropdownRef.current !== null) {
        setOpen(!open)
      }
    }
    if (typeof window !== 'undefined') {
      if (open) {
        window.addEventListener('click', clickEnPagina)
      }
      return () => {
        window.removeEventListener('click', clickEnPagina)
      }
    }
  }, [open])

  return (
    <div className={`${className ? className : ''}  `}>
      <button
        onClick={() => setOpen(!open)}
        className="px-8 py-3 text-white rounded-full bg-azul border-azul">
        Compartir <ShareIcon size={16} />
      </button>
      {open && (
        <div
          ref={dropdownRef}
          className="absolute right-0 z-20 w-48 mt-2 overflow-hidden bg-white rounded-md shadow-xl">
          <WhatsappShareButton
            url={`${shareUrl}${suffix('whatsapp')}`}
            title={`${title} - ${site.siteMetadata.title} ${site.siteMetadata.siteName}`}
            separator=" :: "
            resetButtonStyle={true}
            className="w-full text-sm text-gray-800 appearance-none ">
            <div className="flex items-center justify-end gap-2 px-4 py-2 hover:bg-gray-200">
              <span>Whatsapp</span>
              <WhatsappIcon size={32} round />
            </div>
          </WhatsappShareButton>

          <FacebookShareButton
            url={`${shareUrl}${suffix('facebook')}`}
            hashtag={`#${hashtag}`}
            resetButtonStyle={true}
            className="w-full text-sm text-gray-800 appearance-none ">
            <div className="flex items-center justify-end gap-2 px-4 py-2 hover:bg-gray-200">
              <span>Facebook</span>
              <FacebookIcon size={32} round />
            </div>
          </FacebookShareButton>

          <TwitterShareButton
            url={`${shareUrl}${suffix('twitter')}`}
            title={`${title} - ${site.siteMetadata.title} - ${site.siteMetadata.siteName}`}
            hashtags={[hashtag]}
            via={site.siteMetadata.twitterHandle}
            separator=" :: "
            resetButtonStyle={true}
            className="w-full text-sm text-gray-800 appearance-none ">
            <div className="flex items-center justify-end gap-2 px-4 py-2 hover:bg-gray-200">
              <span>Twitter</span>
              <TwitterIcon size={32} round />
            </div>
          </TwitterShareButton>

          <TelegramShareButton
            url={`${shareUrl}${suffix('telegram')}`}
            title={`${title} - ${site.siteMetadata.title} - ${site.siteMetadata.siteName}`}
            resetButtonStyle={true}
            className="w-full text-sm text-gray-800 appearance-none ">
            <div className="flex items-center justify-end gap-2 px-4 py-2 hover:bg-gray-200">
              <span>Telegram</span>
              <TelegramIcon size={32} round />
            </div>
          </TelegramShareButton>
        </div>
      )}
    </div>
  )
}

export default SocialShare
